import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Sticky } from 'react-sticky';

import styles from '../../../../sass/definitions/_breakpoints.scss';
import * as D from '../../deps';
import { isBackstageRightRailActive } from '../../utils';

import './BackstageLargeHeaderStickySidebar.scss';

const BackstageLargeHeaderStickySidebar = props => {
  const { useStickySidebar, isRightRailActive, children } = props;

  const classNames = D.createBEM('BackstageLargeHeaderStickySidebar', {
    rightRail: isRightRailActive,
  });

  const SidebarContent = <div className={classNames}>{children}</div>;

  if (useStickySidebar) {
    return (
      <Sticky topOffset={-105} stickyStyle={{ top: '105px' }}>
        {SidebarContent}
      </Sticky>
    );
  }
  return SidebarContent;
};

BackstageLargeHeaderStickySidebar.propTypes = {
  useStickySidebar: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  children: PropTypes.node,
};

export function mapStateToProps(state) {
  const { width, height } = D.getViewportDimensions();
  const isBreakWidth = width <= parseInt(styles.BREAK_WIDTH_XS, 10);
  const isBreakHeight = height <= parseInt(styles.BREAK_HEIGHT_XXSM, 10);
  const isMobileView = isBreakWidth || isBreakHeight;

  return {
    useStickySidebar: !isMobileView,
    isRightRailActive: isBackstageRightRailActive(state),
  };
}

export default connect(mapStateToProps)(BackstageLargeHeaderStickySidebar);
